import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch {
      setError('Credenciales incorrectas');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#1a1a2e',
    }}>
      <form onSubmit={handleSubmit} style={{
        background: '#fff', padding: 40, borderRadius: 8, width: 360,
        boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
      }}>
        <h1 style={{ textAlign: 'center', marginBottom: 8, fontSize: 22 }}>WhatsApp Campaigns</h1>
        <p style={{ textAlign: 'center', color: '#888', marginBottom: 24, fontSize: 13 }}>Inicia sesion para continuar</p>
        {error && <div style={{ background: '#f8d7da', color: '#721c24', padding: 10, borderRadius: 4, marginBottom: 16, fontSize: 13 }}>{error}</div>}
        <input
          type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
          required style={{ width: '100%', padding: 12, marginBottom: 12, border: '1px solid #ddd', borderRadius: 4, boxSizing: 'border-box' }}
        />
        <input
          type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
          required style={{ width: '100%', padding: 12, marginBottom: 20, border: '1px solid #ddd', borderRadius: 4, boxSizing: 'border-box' }}
        />
        <button type="submit" disabled={loading} style={{
          width: '100%', padding: 12, background: '#4ecca3', color: '#fff',
          border: 'none', borderRadius: 4, fontSize: 15, cursor: 'pointer',
          opacity: loading ? 0.6 : 1,
        }}>
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
